<template>
    <div class="mx-auto">
        <b-modal
                ref="modal-honorarios-acao-judicial"
                id="modal-honorarios-acao-judicial"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="'Requisição n. ' + itemCarregado.numeroRequisicao"
                header-bg-variant="success"
                header-text-variant="white"
                @hidden="close">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ 'Requisição n. ' + itemCarregado.numeroRequisicao }}</h5>
                <b-button variant="success" @click="relatorioPDF" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
            </template>
            <b-row>
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <CompFiltroGrid
                                ref="compFiltro"
                                :filtro="filtro"
                                compId="popupExtrato"
                                @filtrarResultados="filtrarResultados"
                                @ordenarResultados="ordenarResultados"/>

                        <b-tabs card active-nav-item-class="text-title-selected" v-model="tabIndex">
                            <b-tab title="Dados Básicos" active title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Tipo da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ honorariosAcaoJudicial.tipoRequisicao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Data de Criação:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.dataCriacao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Status Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p :style="'color: ' + honorariosAcaoJudicial.corStatus">{{ honorariosAcaoJudicial.status }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Forma de Pgto.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.formaPagamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Tipo de Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.tipoPagamento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modalidade Parc.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.modalidadeParcelamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Qtde. Parcelas:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p v-if="honorariosAcaoJudicial.tipoPagamento != 'À Vista'">{{ honorariosAcaoJudicial.quantidadeParcelas }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Vlr. da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>R$ {{ honorariosAcaoJudicial.valor | currency }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Percentual Pago:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.percentualPago }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Origem Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.cnj }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Índice de Reajuste:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.indiceReajuste }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Setor Emitente:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.setor }}</p>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Observações:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <pre><p class="texto-scroll" v-html="honorariosAcaoJudicial.observacoes"></p></pre>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="3" md="2">
                                        <label>Docs. Anexados:</label>
                                    </b-col>
                                    <b-col sm="6" md="7">
                                        <span v-for="anexo in honorariosAcaoJudicial.anexos" :key="anexo.codAnexo">
                                        <p>
                                            <a class="link" @click="obterAnexo(anexo)">
                                                {{ anexo.nomeAnexo }}
                                            </a>
                                            <b-button class="ml-2" v-if="perfilAdministrador"
                                                    variant="outline-warning"
                                                    @click="removerAnexo(anexo)">
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </p>
                                        </span>
                                    </b-col>
                                    <b-col sm="3" md="3">
                                        <b-button variant="outline-warning" @click="incluirAnexo" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
                                        <b-form-file v-show="false" @input="realizarUpload" ref="incluir-anexo"></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Devedor" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Devedor:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.nome }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>CPF/ CNPJ:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.documento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>E-mail principal:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.email }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Celular:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.telefone }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Endereço:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.logradouro }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Nº:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.numero }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Complemento:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.complemento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Cidade:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.municipio != null ? honorariosAcaoJudicial.contribuinte.municipio.nome : '' }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Estado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.uf != null ? honorariosAcaoJudicial.contribuinte.uf.nome : '' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>CEP:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.contribuinte.cep }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="12">
                                        <b-button variant="outline-primary" style="float: right;" @click="atualizarCadastro">
                                            <i class="far fa-address-book fa-flip-horizontal icon-button align-middle"></i> Abrir Cadastro do Devedor
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Cálculo" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modo de Cálculo:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.modoCalculo }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Base:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.valorBase }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Percentual:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.percentual }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Vlr. Calculado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.valorCalculado }}</p>
                                    </b-col>
                                </b-row>

                                <hr class="mt-4"/>

                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Correção Monet.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.correcaoMonetaria }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Correção:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.valorCorrigido }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Início da Correção:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.inicioCorrecao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Fim da Correção:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.fimCorrecao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Juros de Mora:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.jurosMora }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor dos Juros:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.valorJuros }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Início dos Juros:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.inicioJuros }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Fim dos Juros:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.fimJuros }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Hono art.523/CPC:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.honorariosArt }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Multa art.523/CPC:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ honorariosAcaoJudicial.multaArt }}</p>
                                    </b-col>
                                </b-row>

                                <hr class="mt-4"/>

                                <b-row class="mt-1 mb-0" v-if="honorariosAcaoJudicial.pagamentosReduzidos.length > 0">
                                    <b-col>
                                        <label>Pagamento(s) Anterior(es) Deduzido(s):</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0 overflow-grid-extrato" v-if="honorariosAcaoJudicial.pagamentosReduzidos.length > 0">
                                    <b-table
                                            id="pagamentosReduzidos"
                                            :items="pagamentosReduzidosTemp"
                                            :fields="fieldsPagamentoReduzido"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhum pagamento anterior deduzido encontrado.</p>
                                        </template>
                                        <template v-slot:head(requisicao)="{ item }">
                                            Requisição <i class="filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Requisição', 'mascara', '', '#########', $event)"></i>
                                        </template>
                                        <template v-slot:head(tipoPagamento)="{ item }">
                                            Tipo Pagamento <i class="filter" :class="!isEmpty(filtros.tipoPagamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Tipo Pagamento', 'checkbox', dados.tiposPagamento, null, $event)"></i>
                                        </template>
                                        <template v-slot:head(valorPago)="{ item }">
                                            Valor Pgto (R$) <i class="filter" :class="!isEmpty(filtros.valorPgto) || filtros.filtrarValorPgto == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Valor Pgto (R$)', 'numerico', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(valorAtualizado)="{ item }">
                                            Valor Atualizado (R$) <i class="filter" :class="!isEmpty(filtros.valorAtualizado) || filtros.filtrarValorAtualizado == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Valor Atualizado (R$)', 'numerico', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:cell(valorPago)="{ item }">
                                            {{ item.valorPago | currency }}
                                        </template>
                                        <template v-slot:cell(valorAtualizado)="{ item }">
                                            {{ item.valorAtualizado | currency }}
                                        </template>
                                    </b-table>
                                </b-row>

                                <b-row class="d-flex justify-content-between" style="margin-top: 10px;" v-if="honorariosAcaoJudicial.pagamentosReduzidos.length > 0 && honorariosAcaoJudicial.totalReduzidos != null">
                                    <b-col class="col-md-8">
                                    </b-col>
                                    <b-col class="col-md-4 text-right">
                                        <div data-v-48ccbe7e="" class="input-group input-group-md mb-2">
                                            <div data-v-48ccbe7e="" class="input-group-prepend">
                                                <span class="input-group-text">
                                                    TOTAL R$:&nbsp; 
                                                    {{ honorariosAcaoJudicial.totalReduzidos }}
                                                </span>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Pagamento(s)" title-link-class="text-title" v-if="honorariosAcaoJudicial.status != 'Encaminhada CES'">
                                <b-row sm="12" md="12" class="d-block">
                                    <b-button v-show="!isFormaPagamentoTransferencia" class="mr-2" variant="outline-warning" @click="anteciparBoleto" :disabled="(honorariosAcaoJudicial.mesFechado ? true : (honorariosAcaoJudicial.possuiIndice ? false : anteciparParcelaBloqueado()))"
                                        :title="'O botão Antecipar Parcelas faz com que sejam antecipadas as parcelas futuras, sendo gerado um único boleto abrangendo o valor de todas as parcelas vincendas com data de vencimento para o último dia útil do mês corrente.'
                                            + (!honorariosAcaoJudicial.possuiIndice ? '\r\nO Índice de Reajuste das parcelas utilizado na emissão desta Requisição ainda não conta com variação cadastrada para o mês anterior ao mês atual. Aguarde o cadastro da variação ou entre em contato com os administradores do sistema.'
											: '')
											+ (honorariosAcaoJudicial.mesFechado    ? '\r\nRequisição à vista, cancelada ou com boleto emitido e ainda não pago/vencido. Aguarde a solução do boleto (pagamento/vencimento) para gerar a antecipação das parcelas restantes.'
											: '')"
      
                                    >
                                        <i class="fa fa-money-check-alt"></i> Antecipar Parcelas
                                    </b-button>
                                    <b-button v-show="!isFormaPagamentoTransferencia" class="mr-2" variant="outline-warning"
                                              @click="abrirModalRescindirParcelamento"
                                              :disabled="requisicaoCancelada() || honorariosAcaoJudicial.tipoPagamento == 'À Vista'"
                                        title="O botão Rescindir Parcelamento faz com que o parcelamento seja rescindido, bem como cancelados todos os boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos)."
                                    >
                                        <i class="fa fa-ban"></i> Rescindir Parcelamento
                                    </b-button>
                                    <b-button variant="outline-primary" @click="enviarEmail" class="mr-2"
                                        :title="`Enviar ${isFormaPagamentoTransferencia ? '' : 'boleto e'} documentação ao devedor`"
                                    >
                                        <i class="far fa-envelope"></i> Enviar por E-mail
                                    </b-button>
                                    <b-button variant="secondary" v-b-modal.modal-cancelar :disabled="desabilitarCancelarEditar()" class="float-right"
                                        title="O botão Cancelar a Requisição permite o cancelamento da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. No caso de parcelamento com parcelas pagas, utilize o botão Rescindir Parcelamento disponível na aba Pagamento(s)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar a Requisição
                                    </b-button>
                                    <b-button variant="warning" class="mr-2 float-right" @click="alterarHonorariosAcaoJudicial" :disabled="desabilitarCancelarEditar()" v-if="exibirEditar"
                                        title="O botão Editar a Requisição permite editar os parâmetros da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. Para a Requisição no status Pendente, caso a edição acarrete a alteração do seu valor, da data de vencimento ou do devedor, o boleto anteriormente gerado na sua criação será automaticamente cancelado, bem como emitido novo boleto com os dados corretos ao final da edição."
                                    >
                                        <i class="fa fa-pen"></i> Editar a Requisição
                                    </b-button>
                                </b-row>
                                <b-row class="text-right mt-3">
                                    <b-button v-show="!isFormaPagamentoTransferencia && exibirEditar" class="mr-2" variant="outline-secondary" @click="cancelarBoleto" :disabled="requisicaoCancelada()"
                                        title="O botão Cancelar Boleto faz com que sejam cancelados todos os boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar Boleto
                                    </b-button>
                                    <b-button v-show="!isFormaPagamentoTransferencia && exibirEditar" class="mr-2" variant="outline-primary" @click="gerarBoleto" :disabled="requisicaoCancelada() || !honorariosAcaoJudicial.possuiIndice"
                                          :title="'O botão Gerar Boleto faz com que sejam cancelados todos os eventuais boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos) e gerados novos boletos para todas as parcelas pendentes e para a parcela do mês corrente.'
                                                + (requisicaoCancelada() || honorariosAcaoJudicial.possuiIndice ? '' : '\r\nO Índice de Reajuste das parcelas utilizado na emissão desta Requisição ainda não conta com variação cadastrada para o mês anterior ao mês atual. Aguarde o cadastro da variação ou entre em contato com os administradores do sistema.')"
                                    >
                                        <i class="fa fa-file-pdf"></i> Gerar Boleto
                                    </b-button>
                                    <b-button v-if="false" class="mr-2" variant="outline-success" @click="reativarParcelamento" :disabled="!podeReativar()"
                                        title="O botão Reativar Parcelamento retoma o parcelamento dos honorários de ação judicial."
                                    >
                                        <i class="fas fa-play"></i> Reativar Parcelamento
                                    </b-button>
                                    <i v-if="false" class="fas fa-info-circle text-info pointer ml-1 align-middle" style="font-size: 1.3rem; cursor: pointer; vertical-align: middle;" v-b-modal.modal-info-reativar></i>
                                </b-row>
                                <b-row class="mt-3 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>{{ getTituloTabela }}</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0 overflow-grid-extrato">
                                    <b-table
                                            id="pagamentos"
                                            ref="tablePagamentos"
                                            :items="getItensPagamento"
                                            :fields="getFieldsPagamento"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhuma parcela encontrada.</p>
                                        </template>
                                        <template v-slot:head(codigoBarras)="{ item }">
                                            Código de Barras <i class="filter" :class="!isEmpty(filtrosParcela.codigoBarras) || filtrosParcela.filtrarCodigoBarras == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Código de Barras', 'texto', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataGeracao)="{ item }">
                                            Data Geração <i class="filter" :class="!isEmpty(filtrosParcela.dataGeracao) || filtrosParcela.filtrarDataGeracao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Geração', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataVencimento)="{ item }">
                                            Data Venc. <i class="filter" :class="!isEmpty(filtrosParcela.dataVencimento) || filtrosParcela.filtrarDataVencimento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Vencimento', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(dataPagamento)="{ item }">
                                            Data Pgto <i class="filter" :class="!isEmpty(filtrosParcela.dataPagamento) || filtrosParcela.filtrarDataPagamento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Data Pgto', 'data', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(valor)="{ item }">
                                            Valor <i v-if="!isFormaPagamentoTransferencia" class="filter" :class="!isEmpty(filtrosParcela.valor) || filtrosParcela.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Valor', 'numerico', '', null, $event)"></i>
                                        </template>
                                        <template v-slot:head(situacao)="{ item }">
                                            Situação <i class="filter" :class="!isEmpty(filtrosParcela.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilterPopup('Situação', 'checkbox', dados.listaSituacaoParcela, null, $event)"></i>
                                        </template>
                                        <template v-slot:cell(codigoBarras)="{ item }">
                                            <b-link @click="buscarPdfBoleto(item)" target="_blank">{{ item.codigoBarras }}</b-link>
                                        </template>
                                        <template v-slot:cell(valor)="{ item }">
                                            {{ item.valor | currency }}
                                        </template>
                                    </b-table>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click=hide()> <i class="fa fa-reply"></i> Voltar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-cancelar"
                id="modal-cancelar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cancelar a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja cancelar a requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar')"> Não</b-button>
                <b-button variant="primary" @click="cancelarRequisicao"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-rescindir-aj"
                id="modal-rescindir-aj"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Rescindir a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja rescindir o parcelamento formalizado através desta requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-rescindir-aj')"> Não</b-button>
                <b-button variant="primary" class="btn-sim-rescindir-aj" @click="rescindirParcelamento"> Sim</b-button>
            </template>
        </b-modal>

        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="loading"
                @salvarDevedor="salvarDevedor"/>

        <ModalEnviarEmail
                ref="modalEnviarEmail"
                :anexos="honorariosAcaoJudicial.anexos"
                :loading="loading"
                @enviarEmail="enviarEmail"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ModalEnviarEmail from "../../shared/components/ModalEnviarEmail"
    import CompFiltroGrid from "../../shared/components/CompFiltroGrid"

    export default {
    props: ['loading'],
    components: { ModalAlterarDevedor, ModalEnviarEmail, CompFiltroGrid },
    mixins: [ formatarMixins ],
    data() {
        return {
            updated: false,
            FORMA_PAGAMENTO_TRANSFERENCIA: 'Transferência',
            urlApi: null,
            token: null,
            idRequisicao: null,
            exibirEditar: false,
            perfilAdministrador: false,
            tabIndex: 0,
            dados: {
                uf: [],
                municipios: [],
                tiposPagamento: [],
                listaSituacaoParcela: []
            },
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            honorariosAcaoJudicial: {
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                modalidadeParcelamento: null,
                quantidadeParcelas: null,
                valor: null,
                quitada: null,
                cnj: null,
                percentualPago: null,
                indiceReajuste: null,
                observacoes: null,
                modoCalculo: null,
                valorBase: null,
                percentual: null,
                valorCalculado: null,
                correcaoMonetaria: null,
                valorCorrigido: null,
                inicioCorrecao: null,
                fimCorrecao: null,
                jurosMora: null,
                valorJuros: null,
                inicioJuros: null,
                fimJuros: null,
                honorariosArt: null,
                multaArt: null,
                totalReduzidos: null,
                bloquearBotoesBoletoMesAnterior: null,
                setor: null,
                anexos: [],
                titularReceita: null,
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                },
                pagamentosReduzidos: [],
                parcelas: [],
                possuiIndice: false,
				mesFechado: false
            },
            pagamentosReduzidosTemp: [],
            fieldsPagamento: [
                {
                    key: 'numeroParcela',
                    label: 'Parcela.'
                },
                {
                    key: 'codigoBarras',
                    label: 'Código de Barras'
                },
                {
                    key: 'dataGeracao',
                    label: 'Data Geração'
                },
                {
                    key: 'dataVencimento',
                    label: 'Data Venc.'
                },
                {
                    key: 'dataPagamento',
                    label: 'Data Pgto'
                },
                {
                    key: 'valor',
                    label: 'Valor'
                },
                {
                    key: 'situacao',
                    label: 'Situação'
                }
            ],
            fieldsPagamentoReduzido: [
                {
                    key: 'requisicao',
                    label: 'Requisição'
                },
                {
                    key: 'tipoPagamento',
                    label: 'Tipo Pagamento'
                },
                {
                    key: 'valorPago',
                    label: 'Valor Pgto (R$)'
                },
                {
                    key: 'valorAtualizado',
                    label: 'Valor Atualizado (R$)'
                }
            ],
            parcelasTemp: [],
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                campoTexto: null,
                campoData: null,
                campoRadio: null,
                campoCheckbox: null,
                listaValores: []
            },
            filtros: {
                numeroRequisicao: null,
                codRequisicao: null,
                tipoPagamento: null,
                filtrarValorPgto: null,
                valorPgto: null,
                filtrarValorAtualizado: null,
                valorAtualizado: null
            },
            filtrosParcela: {
                filtrarCodigoBarras: null,
                codigoBarras: null,
                filtrarDataGeracao: null,
                dataGeracao: null,
                filtrarDataVencimento: null,
                dataVencimento: null,
                filtrarDataPagamento: null,
                dataPagamento: null,
                filtrarValor: null,
                valor: null,
                situacao: null
            }
        }
    },
    computed: {
        getFieldsPagamento () {
            if (this.honorariosAcaoJudicial.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return [
                    {
                        key: 'dataTransferencia',
                        label: 'Data da Transf.'
                    },
                    {
                        key: 'valor',
                        label: 'Valor'
                    },
                    {
                        key: 'validadoSetor',
                        label: 'Validação GOFS'
                    },
                    {
                        key: 'validadoTesoureiro',
                        label: 'Validação Tesoureiro'
                    },
                    {
                        key: 'status',
                        label: 'Situação'
                    }
                ]
            } else {
                return [
                    {
                        key: 'numeroParcela',
                        label: 'Parc.'
                    },
                    {
                        key: 'codigoBarras',
                        label: 'Código de Barras'
                    },
                    {
                        key: 'dataGeracao',
                        label: 'Data Geração'
                    },
                    {
                        key: 'dataVencimento',
                        label: 'Data Venc.'
                    },
                    {
                        key: 'dataPagamento',
                        label: 'Data Pgto'
                    },
                    {
                        key: 'valor',
                        label: 'Valor'
                    },
                    {
                        key: 'situacao',
                        label: 'Situação'
                    }
                ]
            }
        },
        getItensPagamento () {
            if (this.honorariosAcaoJudicial.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return [ this.honorariosAcaoJudicial ]
            } else {
                return this.parcelasTemp
            }
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        getTituloTabela () {
            if (this.honorariosAcaoJudicial.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return 'Transferência:'
            } else {
                return 'Boleto(s) Gerado(s):'
            }
        },
        isFormaPagamentoTransferencia () {
            return this.honorariosAcaoJudicial.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA
        }
    },
    methods: {
        abrirExtrato(item) {
            this.limparMsgsModal();

            this.idRequisicao = item.id;

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/carregarExtrato/${item.tabelaOrigem}/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemCarregado = item;
                this.honorariosAcaoJudicial = response.data || {};
                this.pagamentosReduzidosTemp = [];
                this.honorariosAcaoJudicial.pagamentosReduzidos.forEach(el => {
                    this.pagamentosReduzidosTemp.push(el);
                })
                this.parcelasTemp = [];
                this.honorariosAcaoJudicial.parcelas.forEach(el => {
                    this.parcelasTemp.push(el);
                })
                this.$refs['modal-honorarios-acao-judicial'].show();

                setTimeout(()=>{
                    var tabelas = document.getElementsByClassName("tabelaModal");
                    for (let i = 0; i < tabelas.length; i++) {
                        var inner = tabelas[i].children[0].children[0];
                        inner.style.position = 'sticky';
                        inner.style.top = '-2px';
                    }
                }, 200);
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async obterAnexo(anexo) {
            if(anexo.codAnexo == null) {
                await axios.get(`${this.urlApi}/v1/pesquisas/downloadTermoParcelamento/${this.honorariosAcaoJudicial.tipoOrigem}/${this.idRequisicao}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                }).then(response => {
                    if(!response.data || !response.data.byteLength){
                        this.messageModal = {
                            message: 'Arquivo não encontrado para download.',
                            variant: 'danger'
                        }
                        return;
                    }

                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = anexo.nomeAnexo;
                    link.click();
                }).catch((error) => {
                    this.messageModal = {
                        message: error,
                        variant: 'danger'
                    }
                });
            } else {
                await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                }).then(response => {
                    if(!response.data || response.data == null){
                        this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                        return;
                    }

                    var a = document.createElement("a");
                    a.href = response.data.base64;
                    a.download = response.data.nomeArquivo;
                    a.click();
                }).catch((error) => {
                    this.exibirErro(error)
                });
            }
        },

        async relatorioPDF() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarHonorariosAcaoJudicial/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'honorariosAcaoJudicial' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        cancelarBoleto() {
            this.limparMsgsModal();

            let parcelas = [];
            for(var i = 0; i < this.honorariosAcaoJudicial.parcelas.length; i++) {
                if(this.honorariosAcaoJudicial.parcelas[i].situacao == 'Pendente') {
                    parcelas.push(this.honorariosAcaoJudicial.parcelas[i].codParcela);
                }
            }

            if(parcelas.length == 0) {
                this.messageModal = {
                    message: 'Não existe parcela para ser cancelada',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/boleto/bancobrasil/cancelamento/cancelar/${this.honorariosAcaoJudicial.titularReceita}`, parcelas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(() => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcela cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        abrirModalRescindirParcelamento() {
			this.showModal('modal-rescindir-aj');
        },

        rescindirParcelamento() {
			this.hideModal('modal-rescindir-aj');

            this.limparMsgsModal();

            if((this.honorariosAcaoJudicial.status != 'Em dia' &&
                this.honorariosAcaoJudicial.status != 'Atrasada')
                || (this.honorariosAcaoJudicial.quantidadeParcelas == null || this.honorariosAcaoJudicial.quantidadeParcelas <= 1)) {
                this.messageModal = {
                    message: 'Requisição não pode ser Rescindida.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/rescindirHonorariosAcaoJudicial/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcela rescindida com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        reativarParcelamento() {
            this.limparMsgsModal();

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/reativarHonorariosAcaoJudicial/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcelamento reativado com sucesso.',
                    variant: 'success'
                };
            }).catch(() => {
                this.messageModal = {
                    message: 'Erro ao tentar reativar o parcelamento.',
                    variant: 'danger'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        anteciparBoleto() {
            this.limparMsgsModal();
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/anteciparParcelas/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Não existe boleto a ser gerado',
                        variant: 'danger'
                    };
                    return;
                }
                this.updated = true;
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Boleto' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
                this.abrirExtrato(this.itemCarregado);
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        buscarPdfBoleto (item) {
            this.limparMsgsModal()
            this.loading.showLoading()
            axios.get(`${this.urlApi}/v1/pesquisas/boleto/download/${item.codParcela}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if (!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Boleto não encontrado',
                        variant: 'danger'
                    }
                    return
                }

                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Boleto' + (item.codigoBarras ? item.codigoBarras : 'boleto') + '.pdf'
                link.click()
            }).catch((error) => {
                this.messageModal = {
                    message: 'Boleto não encontrado',
                    variant: 'danger'
                }
                return
            }).finally(() => {
                this.loading.hideLoading()
            })
        },

        gerarBoleto() {
            this.limparMsgsModal();
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/gerarHonorariosAcaoJudicial/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Não existe boleto a ser gerado',
                        variant: 'danger'
                    };
                    return;
                }
                this.updated = true;
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Boleto' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
                this.abrirExtrato(this.itemCarregado);
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        cancelarRequisicao() {
            this.$refs['modal-cancelar'].hide();

            this.limparMsgsModal();

            if(this.honorariosAcaoJudicial.status != 'Aguardando Aprovação' &&
                this.honorariosAcaoJudicial.status != 'Aguardando Validação' &&
                this.honorariosAcaoJudicial.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser cancelada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/cancelarHonorariosAcaoJudicial/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Requisição cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        alterarHonorariosAcaoJudicial() {
            this.limparMsgsModal();

            if(this.honorariosAcaoJudicial.status != 'Aguardando Aprovação' &&
                this.honorariosAcaoJudicial.status != 'Aguardando Validação' &&
                this.honorariosAcaoJudicial.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser alterada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            if(this.$router.currentRoute.fullPath.startsWith('/honorarios-acao-judicial')) {
                this.$emit('obterHonorariosAcaoJudicial', this.itemCarregado.id, false);
                this.$refs['modal-honorarios-acao-judicial'].hide();
            } else {
                this.$store.commit('setHonorariosAcaoJudicial', this.itemCarregado.id);
                this.$router.push({path: '/honorarios-acao-judicial'});
            }
        },

        atualizarCadastro() {
            this.$refs.modalAlterarDevedor.atualizarCadastro(this.honorariosAcaoJudicial.contribuinte);
        },
        enviarEmail () {
            this.$refs.modalEnviarEmail.abrirModalEnviarEmail(this.honorariosAcaoJudicial)
        },
        incluirAnexo () {
            this.$refs['incluir-anexo'].$el.childNodes[0].click()
        },
        realizarUpload (arquivo) {
            this.$store.commit("setMessages", {});
            let arquivoConvertido = null
            if ((arquivo.size / 1024) / 1024 > 50.0) {
                this.messageModal = {
                    message: 'Tamanho do arquivo ultrapassa o limite definido em 50mb.',
                    variant: 'danger'
                };
            } else {
                var reader = new FileReader()
                reader.onload = function (e) {
                    arquivoConvertido = {
                        nomeArquivo: arquivo.name,
                        base64: e.target.result
                    }
                }
                reader.readAsDataURL(arquivo)
                reader.onloadend = () => this.salvarAnexo(arquivoConvertido)
            }
        },
        salvarAnexo (arquivo) {
            let parametros = {
                id: this.honorariosAcaoJudicial.id,
                arquivo: arquivo,
                tipoOrigem: this.honorariosAcaoJudicial.tipoOrigem
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/incluirAnexo`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                let codAnexo = ((response) && (response.data)) ? response.data.id : 0
                this.honorariosAcaoJudicial.anexos.push({
                    codAnexo: codAnexo,
                    nomeAnexo: arquivo.nomeArquivo,
                    base64 : arquivo.base64
                })
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        removerAnexo (arquivo) {
            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/removerAnexo/${arquivo.codAnexo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.honorariosAcaoJudicial.anexos = this.honorariosAcaoJudicial.anexos.filter((anexo) => anexo.codAnexo !== arquivo.codAnexo)
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        salvarDevedor(contribuinte) {
            this.honorariosAcaoJudicial.contribuinte = {
                codContribuinte: contribuinte.codContribuinte,
                nome: contribuinte.nome,
                documento: contribuinte.documento,
                telefone: contribuinte.telefone,
                telefoneAlternativo1: contribuinte.telefonetelefoneAlternativo1,
                telefoneAlternativo2: contribuinte.telefonetelefoneAlternativo2,
                email: contribuinte.email,
                emailAlternativo1: contribuinte.emailAlternativo1,
                emailAlternativo2: contribuinte.emailAlternativo2,
                cep: contribuinte.cep,
                logradouro: contribuinte.logradouro,
                numero: contribuinte.numero,
                complemento: contribuinte.complemento,
                bairro: contribuinte.bairro,
                uf: contribuinte.uf,
                municipio: contribuinte.municipio
            };
            this.messageModal = {
                message: 'Cadastro do Devedor alterado com sucesso!',
                variant: 'success'
            };
            this.updated = true;
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        close() {
            this.$emit('closeModal', this.updated);
            this.updated = false;
        },
        requisicaoCancelada() {
            return this.honorariosAcaoJudicial != null && (this.honorariosAcaoJudicial.status == 'Cancelada' || this.honorariosAcaoJudicial.status == 'Quitada' || this.honorariosAcaoJudicial.status == 'Rescindido');
        },
        anteciparParcelaBloqueado() {
			return this.requisicaoCancelada() || this.honorariosAcaoJudicial.tipoPagamento == 'À Vista';
        },
        desabilitarCancelarEditar() {
            return this.honorariosAcaoJudicial != null && this.honorariosAcaoJudicial.status != 'Aguardando Aprovação' &&
                this.honorariosAcaoJudicial.status != 'Aguardando Validação' &&
                this.honorariosAcaoJudicial.status != 'Pendente';
        },
        podeReativar() {
            // Conforme alinhamento com analistas, a reativação é exclusiva para Protesto.
            // Para Ação Judicial, o botão deve permanecer desativado.
            return false;
        },
        async listarTiposPagamento() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.tiposPagamento = response.data
            })
        },
        openFilterPopup(campo, tipo, values, mascara, event) {
            if(document.getElementById('popupExtrato').style.display == 'block'
                && this.filtro.campoFiltro == campo) {
                this.$refs.compFiltro.closeFilterPopup();
            } else {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.tabIndex == 2) {
                    if(this.filtro.campoFiltro == 'Requisição') {
                        this.filtro.campoMascara = this.filtros.numeroRequisicao;
                    } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                        this.filtro.campoCheckbox = this.filtros.tipoPagamento;
                    } else if(this.filtro.campoFiltro == 'Valor Pgto (R$)') {
                        this.filtro.filtrarEm = this.filtros.filtrarValorPgto;
                        this.filtro.campoTexto = this.filtros.valorPgto;
                    } else if(this.filtro.campoFiltro == 'Valor Atualizado (R$)') {
                        this.filtro.filtrarEm = this.filtros.filtrarValorAtualizado;
                        this.filtro.campoTexto = this.filtros.valorAtualizado;
                    }
                } else {
                    if(this.filtro.campoFiltro == 'Código de Barras') {
                        this.filtro.filtrarEm = this.filtrosParcela.filtrarCodigoBarras;
                        this.filtro.campoTexto = this.filtrosParcela.codigoBarras;
                    } else if(this.filtro.campoFiltro == 'Data Geração') {
                        this.filtro.filtrarEm = this.filtrosParcela.filtrarDataGeracao;
                        this.filtro.campoData = this.filtrosParcela.dataGeracao;
                    } else if(this.filtro.campoFiltro == 'Data Pgto') {
                        this.filtro.filtrarEm = this.filtrosParcela.filtrarDataPagamento;
                        this.filtro.campoData = this.filtrosParcela.dataPagamento;
                    } else if(this.filtro.campoFiltro == 'Data Vencimento') {
                        this.filtro.filtrarEm = this.filtrosParcela.filtrarDataVencimento;
                        this.filtro.campoData = this.filtrosParcela.dataVencimento;
                    } else if(this.filtro.campoFiltro == 'Valor') {
                        this.filtro.filtrarEm = this.filtrosParcela.filtrarValor;
                        this.filtro.campoTexto = this.filtrosParcela.valor;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoCheckbox = this.filtrosParcela.situacao;
                    }
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                if(this.tabIndex == 2) {
                    this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 405);
                } else {
                    this.$refs.compFiltro.openCloseFilterPopup(event, true, 400, 245);
                }
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.tabIndex == 2) {
                this.filtros.codRequisicao = this.honorariosAcaoJudicial.id;
                if(this.filtro.campoFiltro == 'Requisição') {
                    this.filtros.numeroRequisicao = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                    this.filtros.tipoPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Valor Pgto (R$)') {
                    this.filtros.filtrarValorPgto = this.filtro.filtrarEm;
                    this.filtros.valorPgto = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Valor Atualizado (R$)') {
                    this.filtros.filtrarValorAtualizado = this.filtro.filtrarEm;
                    this.filtros.valorAtualizado = this.filtro.campoTexto;
                }

                this.consultarPagamentosDeduzidos();
            } else {
                this.filtrosParcela.codRequisicao = this.honorariosAcaoJudicial.id;
                this.filtrosParcela.tipoOrigem = this.honorariosAcaoJudicial.tipoOrigem;
                if(this.filtro.campoFiltro == 'Código de Barras') {
                    this.filtrosParcela.filtrarCodigoBarras = this.filtro.filtrarEm;
                    this.filtrosParcela.codigoBarras = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data Geração') {
                    this.filtrosParcela.filtrarDataGeracao = this.filtro.filtrarEm;
                    this.filtrosParcela.dataGeracao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Pgto') {
                    this.filtrosParcela.filtrarDataPagamento = this.filtro.filtrarEm;
                    this.filtrosParcela.dataPagamento = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Vencimento') {
                    this.filtrosParcela.filtrarDataVencimento = this.filtro.filtrarEm;
                    this.filtrosParcela.dataVencimento = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.filtrosParcela.filtrarValor = this.filtro.filtrarEm;
                    this.filtrosParcela.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtrosParcela.situacao = this.filtro.campoCheckbox;
                }

                this.consultarParcelas();
            }
        },
        ordenarResultados(order) {
            this.filtros.codRequisicao = this.honorariosAcaoJudicial.id;
            if(this.tabIndex == 2) {
                let campoOrdenacao;
                if(this.filtro.campoFiltro == 'Requisição') {
                    campoOrdenacao = 'requisicaoRepresentacaoJudicialOriginal.numeroRequisicao';
                } else if(this.filtro.campoFiltro == 'Tipo Pagamento') {
                    campoOrdenacao = 'requisicao.tipoPagamento';
                } else if(this.filtro.campoFiltro == 'Valor Pgto (R$)') {
                    campoOrdenacao = 'requisicao.valorPgto';
                } else if(this.filtro.campoFiltro == 'Valor Atualizado (R$)') {
                    campoOrdenacao = 'requisicao.valorAtualizado';
                }

                this.consultarPagamentosDeduzidos(campoOrdenacao, order);
            } else {
                let campoOrdenacao;
                this.filtrosParcela.codRequisicao = this.honorariosAcaoJudicial.id;
                this.filtrosParcela.tipoOrigem = this.honorariosAcaoJudicial.tipoOrigem;
                if(this.filtrosParcela.campoFiltro == 'Código de Barras') {
                    campoOrdenacao = 'parcela.linhaDigitavel';
                } else if(this.filtrosParcela.campoFiltro == 'Data Geração') {
                    campoOrdenacao = 'parcela.dataHoraEmissao';
                } else if(this.filtrosParcela.campoFiltro == 'Data Pgto') {
                    campoOrdenacao = 'parcela.dataHoraBaixaBanco';
                } else if(this.filtrosParcela.campoFiltro == 'Data Vencimento') {
                    campoOrdenacao = 'parcela.dataVencimento';
                } else if(this.filtrosParcela.campoFiltro == 'Valor') {
                    campoOrdenacao = 'parcela.valorPago';
                } else if(this.filtrosParcela.campoFiltro == 'Situação') {
                    campoOrdenacao = 'parcela.situacao';
                }

                this.consultarParcelas(campoOrdenacao, order);
            }
        },
        async consultarPagamentosDeduzidos(campoOrdenacao, order) {
            let ordenacao = '';
            if (campoOrdenacao != null && order != null) {
                ordenacao = `?sortField=${campoOrdenacao}&sortOrder=${order}`;
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/pesquisas/consultarPagamentosDeduzidos${ordenacao}`, this.filtros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.pagamentosReduzidosTemp = response.data;
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        async consultarParcelas(campoOrdenacao, order) {
            let ordenacao = '';
            if (campoOrdenacao != null && order != null) {
                ordenacao = `?sortField=${campoOrdenacao}&sortOrder=${order}`;
            }

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/pesquisas/consultarParcelas${ordenacao}`, this.filtrosParcela, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.parcelasTemp = response.data;
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        async listarSituacaoParcela() {
            axios.get(`${this.urlApi}/v1/boletoNaoEncontrado/listarSituacaoParcela`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.listaSituacaoParcela = response.data;
            })
        },
	    acionarEnter(e) {
		    if(e.key == 'Enter' && this.$refs['modal-rescindir-aj'].isShow) {
			    this.rescindirParcelamento();
		    }
	    },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR' || userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.exibirEditar = true;
                }
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.perfilAdministrador = true;
                }
            }
        }

        this.listarTiposPagamento();
        this.listarSituacaoParcela();

	    setTimeout(()=>{
		    window.addEventListener("keypress", this.acionarEnter);
	    }, 500);
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
